export default "__VITE_ASSET__Cmc20xZT__"